import React from 'react';
import styled from 'styled-components';
import { Colors } from '../../../../../common/colors/colors';
import Icon from '@/common/components/Icon';

const Wrapper = styled.div`
	display: flex;
	justify-content: right;
	gap: 20px;
	padding: 0 10px;
	h3 {
		color: ${Colors.darkBlue};
	}
`;

const CallingTopBar = ({
	handleCall,
	setIsCalling,
	handleEndCall,
	isTalkingTicket,
}) => {
	return (
		<Wrapper>
			{isTalkingTicket ? (
				<Icon
					name='phone-slash'
					style={{ cursor: 'pointer', fontSize: '28px', color: Colors.red }}
					onClick={(e) => handleEndCall(e)}
				/>
			) : (
				<Icon
					name='phone'
					style={{ cursor: 'pointer', fontSize: '28px', color: Colors.green }}
					onClick={(e) => {
						setIsCalling(() => true);
						handleCall(e);
					}}
				/>
			)}
		</Wrapper>
	);
};

export default CallingTopBar;
